<div class="mb-8 flex justify-start gap-40 overflow-auto lg:mb-24 lg:justify-center" role="tablist">
    @for (category of categories(); track $index) {
        <button
            class="font-headline text-14 text-accent md:text-18 border-b-4 leading-27 transition-colors hover:font-medium"
            [ngClass]="{
                'border-b-accent font-medium': category === activeCategory(),
                'border-b-transparent': category !== activeCategory(),
            }"
            [attr.aria-selected]="category === activeCategory()"
            (click)="categorySelected.emit(category)"
            role="tab"
        >
            {{ category }}
        </button>
    }
</div>
<div class="grid grid-cols-2 place-items-center gap-16 md:grid-cols-3 lg:gap-56 xl:grid-cols-4">
    @for (model of filteredModels(); track model.slug) {
        <a
            class="group font-headline relative flex h-full flex-col gap-8 bg-white px-8 pt-32 pb-4 lg:w-[270px] lg:px-24 lg:pb-16"
            [hyundaiRouterLink]="model.detailUrl"
            [queryParams]="model.filterParams"
            blockTriggerPreloading
        >
            <div class="absolute top-8 left-8 flex items-center gap-8 lg:top-12 lg:left-24">
                @if (isHWS && model.campaigns) {
                    <p
                        class="bg-accent text-10 lg:text-16 flex h-[16px] items-center justify-center px-12 leading-27 font-medium text-white lg:h-[22px]"
                    >
                        AKTION
                    </p>
                }
            </div>
            <ui-m000-c010-image
                class="transition-all group-hover:scale-110"
                [image]="{
                    image: model.image.url,
                    desktop: { width: 222, height: 130 },
                    tablet: { width: 222, height: 130 },
                    mobile: { width: 336, height: 192 },
                }"
                [alt]="model.image.alt ?? ''"
                [priority]="isFirstView()"
                cover
            />
            <div class="flex flex-col leading-21">
                <span class="text-14 lg:text-18 font-medium text-black">
                    {{ isHWS ? (model.alternativerModelListName ?? model.name) : model.name }}
                </span>
                <span class="text-12 lg:text-16 leading-20 text-black lg:leading-27">
                    @if (model.count > 0) {
                        {{ model.count | number }} verfügbar
                    } @else {
                        Bei uns bestellbar
                    }
                </span>
            </div>
        </a>
    }

    <ng-content select="[additionalCards]" />
</div>
